import React from 'react';
export function FormPageShimmer() {
  return <div className="space-y-6 animate-pulse" data-id="element-4205">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-4206">
        <div className="h-6 w-48 bg-gray-200 rounded" data-id="element-4207" />
        <div className="flex gap-2" data-id="element-4208">
          <div className="h-10 w-24 bg-gray-200 rounded-md" data-id="element-4209" />
          <div className="h-10 w-24 bg-gray-200 rounded-md" data-id="element-4210" />
        </div>
      </div>
      {/* Form card */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-4211">
        <div className="space-y-6" data-id="element-4212">
          {/* Form sections */}
          {[1, 2].map(section => <div key={section} className="space-y-4" data-id="element-4213">
              <div className="h-5 w-32 bg-gray-200 rounded mb-4" data-id="element-4214" />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-4215">
                {[1, 2, 3, 4].map(i => <div key={i} data-id="element-4216">
                    <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-4217" />
                    <div className="h-10 w-full bg-gray-200 rounded-md" data-id="element-4218" />
                  </div>)}
              </div>
            </div>)}
          {/* Text area */}
          <div data-id="element-4219">
            <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-4220" />
            <div className="h-32 w-full bg-gray-200 rounded-md" data-id="element-4221" />
          </div>
          {/* Action buttons */}
          <div className="flex justify-end gap-2 pt-4 border-t border-gray-200" data-id="element-4222">
            <div className="h-10 w-24 bg-gray-200 rounded-md" data-id="element-4223" />
            <div className="h-10 w-32 bg-gray-200 rounded-md" data-id="element-4224" />
          </div>
        </div>
      </div>
    </div>;
}